"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CookieConsent = /** @class */ (function () {
    function CookieConsent() {
        this.config = {
            localStorageKey: 'hasConsent',
            htmlElements: {
                panel: null,
                close: null
            },
            selectors: {
                panel: '[data-cookie-consent]',
                close: '[data-cookie-consent-close]'
            }
        };
    }
    CookieConsent.prototype.init = function () {
        var hasConsent = window.localStorage.getItem(this.config.localStorageKey);
        this.config.htmlElements.panel = document.querySelector(this.config.selectors.panel);
        this.config.htmlElements.close = document.querySelector(this.config.selectors.close);
        if (hasConsent !== '')
            this.config.htmlElements.panel.classList.remove('hide');
        this.addEventListeners();
    };
    CookieConsent.prototype.addEventListeners = function () {
        this.config.htmlElements.close.addEventListener('click', this.handleCloseClick.bind(this));
    };
    CookieConsent.prototype.handleCloseClick = function () {
        window.localStorage.setItem(this.config.localStorageKey, '');
        this.config.htmlElements.panel.classList.add('hide');
    };
    return CookieConsent;
}());
exports.default = new CookieConsent();
